// https://gist.github.com/prosenjit-manna/19e7031894fae4039ac4dec20014a311#file-form-validation-ts


import * as yup from "yup"
import './yupOptional'

import { cleanSsn } from './lib/strFunctions/cleanSsid'
// import { IAppForm } from "./lib/interfaces/models";
// import "yup-phone";
import "yup-phone-lite"
import { verifyEmail } from "./service/emailVerifier";
// import { debounce } from "lodash";

// const verifyE = async function (value: string) {
//   try {
//     const res = await verifyEmail(value);

//       return res.status ? true : false;
    
//   } catch (e) {

//     return false;
//   }
// };

// const verifyEm = async function (value: string, values: yup.TestContext<any>) {
//   try {
//     const res = await verifyEmail(value);

//       return res.status;
    
//   } catch (e) {
//     values.createError({ path: 'email' });
//     return false;
//   }
// };

// const verifyEmm = async (value: string) => {
//   console.log('verifyEmm called with', value)
//   await verifyEmail(value)
//   .then((da) => {
//     console.log('from then', da.status)
//     return da.status

//   })
// }

// const debounceVerifyEmail = debounce(verifyEmm, 1000)


export const validationSchema = yup.object().shape({

  ssid: yup
    .string()
    .required('Vantar')
    .test('validator-custom-ssid', function (value) {
      const validation = cleanSsn(value);
      if (validation.error || !validation.ssn) {
        return this.createError({
          path: this.path,
          message: 'Kt stenst ekki',
        });
      }
      else {
        return true;
      }
    }),
  name: yup
    .string()
    .required('Vantar')
    .min(5, 'Nafn er of stutt'),



  email1: yup
    .string()
    .required('Vantar')
    .email('Ógilt netfang')
    // .test('validator', 'Netfang með vesen', function(value) {

    //   if (!verifyE(value)) {
    //     return this.createError({
    //       path: this.path,
    //       message: 'Netfang ekki til',
    //     })
    //   }

     
      


    // })

    // .test('email-validator', async function (value) {
    //   const emailvalidation = await verifyEmail(value)
    //   console.log('validation', emailvalidation)
    //   if (emailvalidation.error) {
    //     return this.createError({
    //       path: this.path,
    //       message: emailvalidation.message,
    //     })
    //   }
    //   else {
    //     return true
    //   }
    // })
    ,
  email2: yup
    .string()
    .email('Ógilt netfang'),
  email3: yup
    .string()
    .email('Ógilt netfang'),
  tel1: yup
    .string()
    .phone('IS', 'Stenst ekki'),
  tel2: yup
    .string()
    .phone('IS', 'Stenst ekki'),
  tel3: yup
    .string()
    .phone('IS', 'Stenst ekki'),
  oschool: yup
    .number().typeError('Veldu')
    .required('Veldu'),

  oschoolclass: yup
    .number().typeError('Veldu')
    .required('Veldu')
  ,
  prev: yup
    .number().typeError('Veldu')
    .required('Veldu'),
  prevText: yup
    .string()
    .max(250, "hámark 250 stafabil"),
  familyText: yup
    .string()
    .max(250, "hámark 250 stafabil"),
  comment: yup
    .string()
    .max(600, "hámark 600 stafabil"),


  guardians: yup.array(
    yup.object({
      ssid: yup
        .string()
        .required('Vantar')
        .test('validator-custom-ssid', function (value) {
          const validation = cleanSsn(value);
          if (validation.error || !validation.ssn) {
            return this.createError({
              path: this.path,
              message: 'Kt stenst ekki',
            });
          }
          else if (validation.minor) {
            return this.createError({
              path: this.path,
              message: 'Forráðamaður þarf að vera amk 18 ára'
            });
          }
          else {
            return true;
          }
        }),
      name: yup
        .string()
        .required('Vantar')
        .min(5, 'Nafn er of stutt'),
      email1: yup
        .string()
        .required('Vantar')
        .email('Ógilt netfang'),
      email2: yup
        .string()
        .email('Ógilt netfang'),
      email3: yup
        .string()
        .email('Ógilt netfang'),
      tel1: yup
        .string()
        .phone('IS', 'Stenst ekki'),
      tel2: yup
        .string()
        .phone('IS', 'Stenst ekki'),
      tel3: yup
        .string()
        .phone('IS', 'Stenst ekki'),
    }),
  ),

  subjects: yup.array(
    yup.object({
      id: yup.number().typeError('Námsgrein vantar')
      .test('validator-custom-ssid', function (value) {
        if (!value) {
          return this.createError({
            path: this.path,
            message: 'Námsgrein vantar'
          })
        }
        else {
          return true;
        }
      })
    })
  ),
  terms: yup
    .boolean()
    .test('term-validate', function (value) {
      // console.log('yup terms value', value)
      if (!value) {
        return this.createError({
          path: this.path,
          message: 'Samþykki er nauðsynlegt'
        })
      }
      else {
        return true
      }
    }),
  email: yup
    .boolean()
    .test('term-validate', function (value) {
      if (!value) {
        return this.createError({
          path: this.path,
          message: 'Samþykki er nauðsynlegt'
        })
      }
      else {
        return true
      }
    }),
  elschool: yup
    .number()
    .test('term2-validate', function (value) {
      console.log('elschool',value)
      if (value !== 0 && value !== 1 && value !== 2) {
        return this.createError({
          path: this.path,
          message: 'Veldu Já eða Nei'
        })
      }
      else {
        return true
      }
    }),
    media: yup
    .number()
    .test('term2-validate', function (value) {
      console.log('media',value)
      if (value !== 0 && value !== 1 && value !== 2) {
        return this.createError({
          path: this.path,
          message: 'Veldu Já eða Nei'
        })
      }
      else {
        return true
      }
    }),
    mobile: yup
    .number()
    .test('term2-validate', function (value) {
      console.log('mobile',value)
      if (value !== 0 && value !== 1 && value !== 2) {
        return this.createError({
          path: this.path,
          message: 'Veldu Já eða Nei'
        })
      }
      else {
        return true
      }
    }),







  // title: yup.string().required().min(2).max(120).label("Title"),
  // date: yup
  //   .date()
  //   .required()
  //   .min(today, "Date must be today or later")
  //   .label("Date"),
  // plan: yup
  //   .string()

  //   .min(2)
  //   .required(),
  // //   .string()
  // //   .oneOf([AppointmentPlan.Basic, AppointmentPlan.Premium])
  // //   .required()
  // //   .label("Plan"),
  // contact: yup.object({
  //   firstName: yup.string().required().min(2).max(120).label("First name"),
  //   // lastName: yup.string().required().min(2).max(120).label("Last name"),
  //   phoneNumber: yup.string().required("Vantar").phone("IS", "Íslenskt símanúmer").label("Phone number"),
  //   email: yup.string().email().label("Email"),
  //   callMeBack: yup.boolean().required().label("Callback"),
  // }),
  // pets: yup.array(
  //   yup.object({
  //     name: yup.string().required().min(2).max(120).label("Name"),
  //     breed: yup.string().required().min(2).max(120).label("Breed"),
  //     description: yup.string().min(2).max(120).label("Description"),
  //   })
  // ),
});

validationSchema.describe({value: {_oschoolclass: true}})
